<template>
	<div class="gvf">
		<v-text-field
			:disabled="isNull"
			:tabindex="tabIndex"
			@change="changeValue()"
			:label="gridViewField.Label"
			v-model="value"
			:rules="textFieldRule"
			clearable
			hide-details="auto"
		>
		</v-text-field>

		<v-checkbox
			v-if="isBulkEdit"
			v-model="isNull"
			label="Set field to null"
			class="ma-0"
			hide-details
			@change="changeValue()"
		></v-checkbox>
	</div>
</template>
<script>
import gridViewFieldsUtils from '../../../../utils/gridViewFieldsUtils';
import gridFieldMixin from '../../../../mixins/grids/gridFieldMixin';
export default {
	name: 'TextField',
	mixins: [gridFieldMixin],
	data() {
		return {
			value: null,
			textFieldRule: [
				(v) => {
					if (!v) return true;
					return (
						v.length <= 255 || 'The length must be lower than 255'
					);
				},
			],
		};
	},
	mounted() {
		if (this.record && this.key && this.record[this.key]) {
			this.value = this.record[this.key];
		}
	},
	methods: {
		changeValue() {
			let recordKey;
			if (this.isNull) {
				recordKey = [{ key: this.key, value: null }];
				this.value = null;
			} else {
				recordKey = [{ key: this.key, value: this.value }];
			}
			let itemKey = [
				{
					key: gridViewFieldsUtils.getFieldName(this.gridViewField),
					value: this.value,
				},
			];
			this.$emit('valueChanged', itemKey, recordKey, this.isNull);
		},
	},
};
</script>
